import React, { useEffect } from 'react'
import router from '../router'
import { useRoutes } from 'react-router-dom'
import initReactFastclick from 'react-fastclick'
import 'default-passive-events' // 解决 https://blog.csdn.net/Wildness_/article/details/123190078
import VConsole from 'vconsole'
import cloudInitGuideToLogin from '@/actions/cloudInitGuideToLogin'
// import cloudInit from './actions/cloudInit'
import * as toolsStorage from '@/tools/storage'
import i18n from '@/actions/locales'
import OtaUpdateProgess from './components/OtaUpdateProgess'



function App() {
  const element = useRoutes(router)
  const userInfo = toolsStorage.getItem('userInfo')

  // 接入登录
  cloudInitGuideToLogin()

  // 云端
  // cloudInit()
 
 
  useEffect(() => {
    // saveDomainToStorage() // 打开应用保存域名
   
    // 把h5语言环境传递给flutter
    window && window?.jsBridge?.callHandler?.setLanguage(toolsStorage.getItem('i18nextLng') || 'en-US');

    // 从app页面返回时同步语言设置，避免页面刷新
    console.log('toggle flutter env lang1-h5::::222222:', toolsStorage.getItem('i18nextLng') || 'en-US')
    window && window?.jsBridge?.onPageResume(function() {
      window?.jsBridge?.getLanguage(function(data) {
        console.log('toggle flutter env lang2:::::', data)
        const currentLang = toolsStorage.getItem('i18nextLng');
        const appLang = data.language;
        
        // 只有当语言不同时才进行切换
        // if (currentLang !== appLang) {
          toolsStorage.setItem('i18nextLng', appLang);
          // 使用i18n的changeLanguage方法动态切换语言，无需刷新页面
          i18n.changeLanguage(appLang);
        // }
      });
    });

    // 移动端调试工具
    if(process.env.BASE_ENV=== 'development') {
      const vConsole = new VConsole()
    }
    initReactFastclick()
  }, [])
  return <>{element}<OtaUpdateProgess /></>
}

export default App
